import React, { useState, useContext } from "react";
import { TextInput , ImageBackground, StyleSheet, Text, View, Button } from "react-native";
// import { getAuth, signInWithEmailAndPassword } from "../utils/firebaseConfig";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import Inputbox from "../components/Inputbox";
import { AuthContext } from "../store/auth-context";
import { style_templates } from "../config_variables/styles";

export default function LoginScreen({ navigation }) {
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loginFailed, setLoginFailed] = useState(false);

  const authCtx = useContext(AuthContext);

  const storeInputHandler = (type, x) => {
    //     console.log("type: " + type + " | x : " + x);
    type === "Username" ? setUserName(x) : setPassword(x);
  };

  const loginHandler = () => {
    console.log("execute login steps");
    const auth = getAuth();
    //     signInWithEmailAndPassword(auth, "sumeet@resimaxgroup.com.au", "Tuc47069");
    signInWithEmailAndPassword(auth, username, password, true)
      .then((userCredential) => {
        const user = userCredential.user;
        // console.log("userCredential: " + JSON.stringify(userCredential));
        // console.log("user: " + JSON.stringify(user));
        // console.log("user.email: " + user.email);
        // console.log("user.stsTokenManager: " + user.stsTokenManager);
        // console.log(
        //   "user.stsTokenManager.expirationTime: " +
        //     user.stsTokenManager.expirationTime
        // );
        // console.log(
        //   "Token Expiry Time: " +
        //     console.log(new Date(user.stsTokenManager.expirationTime))
        // ); //  console.log("userCredential.idToken " + userCredential.idToken);
        // console.log("çurrent timestamp : " + new Date());
        // if (new Date() > new Date(user.stsTokenManager.expirationTime)) {
        //   console.log("timestamp has expired");
        // } else {
        //   console.log("timestamp is valid");
        // }
        // console.log(
        //   "userCredential._tokenResponse.idToken " +
        //     userCredential._tokenResponse.idToken
        // );
        //  );
        authCtx.authenticate(
          userCredential._tokenResponse.idToken,
          user.stsTokenManager.expirationTime
        );

        // navigation.navigate("Home");
      })
      .catch((error) => {
        console.log("error: " + error);
        setLoginFailed(true);
      });
  };

  return (
    <>
      <View style={style_templates.home_screen_container}>
        {/* <Text style={style_templates.homescreentitle}>
          BTR MILESTONE TRACKER{" "}
        </Text> */}
        <ImageBackground
          source={require("../assets/loginscreen.jpg")}
          resizeMode="cover"
          imageStyle={style_templates.home_screen_image}
        >
          <View style={style_templates.login_sub_container}>
            <Text style={style_templates.login_page_header_text}>RESIMAX INVENTORY MANAGEMENT </Text> 
            <View style={style_templates.login_fields_container}>
              <Inputbox 
                label="Username"
                storeInputHandler={storeInputHandler}
                placeholder="Username / Email"                
                buttonname= "username"
              ></Inputbox >
              <Inputbox 
                label="Password"
                storeInputHandler={storeInputHandler}
                placeholder="Password"
                buttonname= "password"
              ></Inputbox >
              <Text></Text>
              <Button onPress={loginHandler} title="LOGIN"></Button>
              <View style={style_templates.error_message_box}>
                {loginFailed && (
                  <Text style={style_templates.error_message_text}>
                    Login Attempt Failed !!!
                  </Text>
                )}
                  {/* <View style={[style_templates.screen1_header, {marginTop:270, backgroundColor: "transparent"} ]}> */}
                  {/* <View style={[style_templates.screen1_header, {marginTop:220} ]}>
                        <Text style={{fontFamily: "Open Sans", fontSize: 10, color: "rgb(188, 177, 177)"}}>
                              {'\n'}
                              Version : 1.1.0   {'\n'}
                              Latest release : 21 Sep 2022   {'\n'}
                              Developer : Sumeet Panda  {'\n'} 
                              Technology Stack : @ nodejs v16.14.0,  react v17.0.2  {'\n'} {'\n'}
                        </Text>
                  </View>                 */}
                  <View style={[style_templates.login_screen_header, {marginTop:0,justifyContent:"center", alignItems: "center", alignContent:"center"} ]}>
                        <Text style={{fontFamily: "Segoe UI", fontSize: 10, color: "rgb(10, 10, 10)"}}>
                              {'\n'}
                              Version : 2.0.3   | Release Date : 13 Dec 2022   {'\n'} 
                              Developer : Sumeet Panda  {'\n'} 
                              Technology Stack :  nodejs v16.14.0,  react v17.0.2  {'\n'} {'\n'}
                        </Text>
                  </View>
              </View>
            </View>
          </View>
        </ImageBackground>
      </View>
    </>
  );
}
